export const environment = {
  giveawayLineaId: 4,
  defaultLineaId: 1,
  name: 'prod',
  production: false,
  apiUrl: 'https://agilcredonline.backend.quo.ar/api',
  googleCaptchaKey: '6Leex0olAAAAAFAXkr0dG6HNXuyorQSQWX-CsoeF',
  getTokenKey: 'getToken',
  loggedTokenKey: 'getLoggedToken',
  loggedData: 'loggedData',
  dateFormat: 'yyyy-MM-dd',
  ipInfoToken: '3581a3eed31b38',
  aes: {
    key: 'cgmL;qd._NHjb@26&k;CyVnS5fTwzB7@',
    iv: ':EQn@,NsH6&E;Jp/',
  },
} as const;
